import script from "./rec-additional-info.vue?vue&type=script&lang=ts&setup=true"
export * from "./rec-additional-info.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__